import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c9baa5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "row bg-white",
  style: {"height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/VerifiLogo.png",
    width: "110",
    "min-height": "100",
    class: "d-inline-block align-top",
    alt: "",
    style: {"margin-top":"9.75px","margin-left":"19.5px"}
  }),
  /*#__PURE__*/_createElementVNode("p", {
    class: "text-muted",
    style: {"font-size":"8px","margin-left":"20px"}
  }, "Guided Sterilization System")
], -1))
const _hoisted_3 = { class: "col" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"calc(100% - 600px)","max-height":"60px"} }, null, -1))
const _hoisted_5 = {
  class: "page d-flex flex-row flex-column-fluid modal-body my-3 py-0",
  style: {"justify-content":"right","display":"flex"}
}
const _hoisted_6 = {
  class: "btn-group-vertical btn-group-lg ml-4 mt-0 btn-huge row",
  role: "group",
  "aria-label": "Basic example"
}
const _hoisted_7 = {
  class: "row d-flex justify-content-center",
  style: {"text-align":"center"}
}
const _hoisted_8 = {
  key: 0,
  style: {"font-size":"25px !important"}
}
const _hoisted_9 = {
  key: 1,
  style: {"font-size":"25px !important"}
}
const _hoisted_10 = { class: "row d-flex justify-content-center mb-2" }
const _hoisted_11 = { class: "row d-flex justify-content-center" }
const _hoisted_12 = { class: "row d-flex justify-content-center" }
const _hoisted_13 = { class: "row d-flex justify-content-center" }
const _hoisted_14 = { class: "row d-flex justify-content-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "mt-4",
  style: {"font-size":"20px !important"}
}, "Delete", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "mt-4",
  style: {"font-size":"20px !important"}
}, "Clear", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "col" }
const _hoisted_20 = {
  class: "navbar navbar-light d-flex my-0 py-10",
  style: {"background":"rgba(0, 0, 0, 0)"}
}
const _hoisted_21 = {
  key: 0,
  class: "p-3",
  id: "navbarNavDropdown",
  style: {"position":"absolute","right":"1%","top":"15%","z-index":"10"}
}
const _hoisted_22 = { class: "nav navbar-nav" }
const _hoisted_23 = { class: "nav-item active" }
const _hoisted_24 = {
  class: "nav-link",
  href: "#",
  id: "navbarDropdown",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false",
  style: {"text-align":"right","white-space":"nowrap"}
}
const _hoisted_25 = {
  class: "dropdown-menu",
  "aria-labelledby": "navbarDropdown",
  style: {"border":"1px solid grey","text-align":"center"}
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"font-weight":"normal"} }, "Sign Out", -1))
const _hoisted_27 = [
  _hoisted_26
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_ctx.incorrectPin)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "PIN is incorrect"))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, "Enter PIN"))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: _normalizeClass(`pins col-4 btn-circular-pin ${
                _ctx.pin.length >= 1 ? 'filled' : 'empty'
              }`)
            }, null, 2),
            _createElementVNode("button", {
              class: _normalizeClass(`pins col-4 btn-circular-pin ${
                _ctx.pin.length >= 2 ? 'filled' : 'empty'
              }`)
            }, null, 2),
            _createElementVNode("button", {
              class: _normalizeClass(`pins col-4 btn-circular-pin ${
                _ctx.pin.length >= 3 ? 'filled' : 'empty'
              }`)
            }, null, 2),
            _createElementVNode("button", {
              class: _normalizeClass(`pins col-4 btn-circular-pin ${
                _ctx.pin.length >= 4 ? 'filled' : 'empty'
              }`)
            }, null, 2)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              type: "button",
              class: "col-4 btn-circular",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.keyPress('1')))
            }, " 1 "),
            _createElementVNode("button", {
              type: "button",
              class: "col-4 btn-circular",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.keyPress('2')))
            }, " 2 "),
            _createElementVNode("button", {
              type: "button",
              class: "col-4 btn-circular",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.keyPress('3')))
            }, " 3 ")
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              type: "button",
              class: "col-4 btn-circular",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.keyPress('4')))
            }, " 4 "),
            _createElementVNode("button", {
              type: "button",
              class: "col-4 btn-circular",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.keyPress('5')))
            }, " 5 "),
            _createElementVNode("button", {
              type: "button",
              class: "col-4 btn-circular",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.keyPress('6')))
            }, " 6 ")
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              type: "button",
              class: "col-4 btn-circular",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.keyPress('7')))
            }, " 7 "),
            _createElementVNode("button", {
              type: "button",
              class: "col-4 btn-circular",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.keyPress('8')))
            }, " 8 "),
            _createElementVNode("button", {
              type: "button",
              class: "col-4 btn-circular",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.keyPress('9')))
            }, " 9 ")
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              type: "button",
              class: "col-4 btn-circular",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.backSpace && _ctx.backSpace(...args)))
            }, _hoisted_16),
            _createElementVNode("button", {
              type: "button",
              class: "col-4 btn-circular",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.keyPress('0')))
            }, " 0 "),
            _createElementVNode("button", {
              type: "button",
              class: "col-4 btn-circular",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args)))
            }, _hoisted_18)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("nav", _hoisted_20, [
        (_ctx.clinicInfo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("ul", _hoisted_22, [
                _createElementVNode("li", _hoisted_23, [
                  _createElementVNode("a", _hoisted_24, [
                    _createElementVNode("h2", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.clinicInfo.name), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      href: "#",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.logOut()))
                    }, _hoisted_27)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}